// Breakpoints configuration for responsive design
export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

// Responsive spacing configuration
export const spacing = 8;

// Shape configuration
export const shape = {
  borderRadius: 3,
};

export default {
  breakpoints,
  spacing,
  shape,
};
